import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./componenets/ScrollToTop";
import ErrorBoundary from "./componenets/ErrorBoundary";
import NotFound from "./componenets/NotFound";
import ScrollToHashElement from "./scrollToHashElement";
// import { Toaster } from "react-hot-toast";

// Lazy-loaded routes and layout components
const Homepage = React.lazy(() => import('./componenets/HomePage'));
const Header = React.lazy(() => import("./componenets/Headers"));
const Footer = React.lazy(() => import("./componenets/Footer"));

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <React.Suspense fallback={<div>Loading...</div>}>
          <div className="2xl:max-w-[1980px] mx-auto">
            <div className="">
              <Header />
              {/* <Toaster position="top-right" /> */}
              <ScrollToTop />
              <ScrollToHashElement/>
              <RouterRoutes>
                {/* Define your routes here */}
                <Route path="/" element={<Homepage />} />
                <Route path="*" element={<NotFound />} />
              </RouterRoutes>
            </div>
            <div className=" bg-[#EFEFEF]">
              <Footer />
            </div>
          </div>
        </React.Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
